/*
 --------------------------------------------------
 --------------------------------------------------
     Table Name : LU_ApplicationDataTypes
 --------------------------------------------------
 --------------------------------------------------
 DO NOT MODIFY MANUALLY
 --------------------------------------------------
 -------------------------------------------------- */

// Types
export type CPR_EVENTS = 'CPR_EVENTS';
export type EVENT_LOG = 'EVENT_LOG';
export type EVENTS_DATA = 'EVENTS_DATA';
export type LAERDAL_CPR_EVENTS = 'LAERDAL_CPR_EVENTS';
export type LAERDAL_CPR_GUIDELINES = 'LAERDAL_CPR_GUIDELINES';
export type LAERDAL_CPR_WAVES = 'LAERDAL_CPR_WAVES';
export type LAERDAL_DEVICE_INFO = 'LAERDAL_DEVICE_INFO';
export type LAERDAL_EVENT_LOG = 'LAERDAL_EVENT_LOG';
export type LAERDAL_SSJ = 'LAERDAL_SSJ';
export type LAERDAL_SSX = 'LAERDAL_SSX';
export type LAERDAL_VITAL_SIGNS_LOG = 'LAERDAL_VITAL_SIGNS_LOG';
export type LLEAP_PLUGIN_SIM_EVENTS = 'LLEAP_PLUGIN_SIM_EVENTS';
export type SIM_DATA = 'SIM_DATA';
export type UNKNOWN_TYPE = 'UNKNOWN_TYPE';
export type VITAL_SIGNS_LOG = 'VITAL_SIGNS_LOG';

export type ApplicationDataType =
    | CPR_EVENTS
    | EVENT_LOG
    | EVENTS_DATA
    | LAERDAL_CPR_EVENTS
    | LAERDAL_CPR_GUIDELINES
    | LAERDAL_CPR_WAVES
    | LAERDAL_DEVICE_INFO
    | LAERDAL_EVENT_LOG
    | LAERDAL_SSJ
    | LAERDAL_SSX
    | LAERDAL_VITAL_SIGNS_LOG
    | LLEAP_PLUGIN_SIM_EVENTS
    | SIM_DATA
    | UNKNOWN_TYPE
    | VITAL_SIGNS_LOG;

// Constants
export const CPR_EVENTS: ApplicationDataType = 'CPR_EVENTS' as const;
export const EVENT_LOG: ApplicationDataType = 'EVENT_LOG' as const;
export const EVENTS_DATA: ApplicationDataType = 'EVENTS_DATA' as const;
export const LAERDAL_CPR_EVENTS: ApplicationDataType = 'LAERDAL_CPR_EVENTS' as const;
export const LAERDAL_CPR_GUIDELINES: ApplicationDataType = 'LAERDAL_CPR_GUIDELINES' as const;
export const LAERDAL_CPR_WAVES: ApplicationDataType = 'LAERDAL_CPR_WAVES' as const;
export const LAERDAL_DEVICE_INFO: ApplicationDataType = 'LAERDAL_DEVICE_INFO' as const;
export const LAERDAL_EVENT_LOG: ApplicationDataType = 'LAERDAL_EVENT_LOG' as const;
export const LAERDAL_SSJ: ApplicationDataType = 'LAERDAL_SSJ' as const;
export const LAERDAL_SSX: ApplicationDataType = 'LAERDAL_SSX' as const;
export const LAERDAL_VITAL_SIGNS_LOG: ApplicationDataType = 'LAERDAL_VITAL_SIGNS_LOG' as const;
export const LLEAP_PLUGIN_SIM_EVENTS: ApplicationDataType = 'LLEAP_PLUGIN_SIM_EVENTS' as const;
export const SIM_DATA: ApplicationDataType = 'SIM_DATA' as const;
export const UNKNOWN_TYPE: ApplicationDataType = 'UNKNOWN_TYPE' as const;
export const VITAL_SIGNS_LOG: ApplicationDataType = 'VITAL_SIGNS_LOG' as const;

const LU_ApplicationDataTypes = {
    CPR_EVENTS,
    EVENT_LOG,
    EVENTS_DATA,
    LAERDAL_CPR_EVENTS,
    LAERDAL_CPR_GUIDELINES,
    LAERDAL_CPR_WAVES,
    LAERDAL_DEVICE_INFO,
    LAERDAL_EVENT_LOG,
    LAERDAL_SSJ,
    LAERDAL_SSX,
    LAERDAL_VITAL_SIGNS_LOG,
    LLEAP_PLUGIN_SIM_EVENTS,
    SIM_DATA,
    UNKNOWN_TYPE,
    VITAL_SIGNS_LOG,
} as const;

export default LU_ApplicationDataTypes;
